export const AUTH_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const ID_TOKEN = "idToken";
export const FCM_TOKEN = "fcmToken";
export const CANCELLED_ORDERS_COUNT = "cancelledOrdersCount";
export const CANCELLED_ORDERS_WARNING_CLOSED = "cancelledOrdersWarningClosed";

export const isVehicleOwner = (userProfile: any) => {
  return userProfile?.user?.roles[0]?.roleCode === "VEHICLE_OWNER";
};

export const isShipper = (userProfile: any) => {
  return userProfile?.user?.roles[0]?.roleCode === "SHIPPER";
};

export const isPlatformAdmin = (userProfile: any) => {
  return userProfile?.user?.roles?.[0]?.roleCode?.startsWith("PLATFORM_ADMIN");
};

export const isStaff = (userProfile: any) => {
  return userProfile?.user?.roles?.[0]?.roleCode?.startsWith("STAFF_");
};

export const canSeeContractOwnerData = (userProfile: any) => {
  if (isVehicleOwner(userProfile) && !userProfile?.user?.contractOwner) {
    return false;
  }
  return true;
};
